






















































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import Calendar from "../general/Calendar.vue";
import BirthdaysBirthdayDetails from "./BirthdaysBirthdayDetails.vue";

import CalendarUtils from "../../shared/CalendarUtils";
import CalendarEventJson from "../../shared/CalendarEventJson";
import BirthdayBookingJson from "../../shared/BirthdayBookingJson";

import { BirthdayBookingStatus } from "../../shared/BirthdayBookingStatus";

export default Vue.extend({
  name: "BirthdaysCalendar",
  components: {
    Loading,
    Calendar,
    BirthdaysBirthdayDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      CalendarUtils: CalendarUtils,
      loading: false,
      showDetails: false,
      selectedReservedAndBookedBirthdays: null as BirthdayBookingJson[] | null,
      dateToShow: null as Date | null,
      currentCalenderYearMonth: null as [number, number] | null,
      selectedBirthdayId: null as number | null,
      selectedBirthday: null as BirthdayBookingJson | null,
      detailsMode: "read",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    loadData() {},

    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadSelectedBirthdays();
      }
    },

    reloadSelectedBirthdays() {
      this.loadSelectedReservedAndBookedBirthdays();
    },

    async loadSelectedReservedAndBookedBirthdays() {
      if (this.currentCalenderYearMonth != null) {
        this.selectedReservedAndBookedBirthdays = null;

        var states: BirthdayBookingStatus[] = [
          BirthdayBookingStatus.requestedStaffRequired,
          BirthdayBookingStatus.requestedNoStaffAvailable,
          BirthdayBookingStatus.requestedPendingConfirmation,
          BirthdayBookingStatus.offerToCustomer,
          BirthdayBookingStatus.booked,
          BirthdayBookingStatus.readyForPayment,
          BirthdayBookingStatus.paymentExported,
        ];
        var afterDateTime = new Date(this.currentCalenderYearMonth[0], this.currentCalenderYearMonth[1], 1);
        var beforeDateTime = new Date(this.currentCalenderYearMonth[0], this.currentCalenderYearMonth[1], 32);

        if (this.restClient != null) {
          try {
            var result = await this.restClient.getBirthdayBookings(
              states,
              null,
              afterDateTime,
              beforeDateTime,
              null,
              null,
              null
            );
            var birthdayBookings = result.birthdayBookings;

            while (result.moreAvailable) {
              result = await this.restClient.getBirthdayBookings(
                states,
                null,
                afterDateTime,
                beforeDateTime,
                null,
                null,
                birthdayBookings.length
              );
              birthdayBookings = birthdayBookings.concat(result.birthdayBookings);
            }

            this.selectedReservedAndBookedBirthdays = birthdayBookings;
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    jumpToDateInCal(date: Date) {
      this.dateToShow = date;
    },

    /* birthdaysAtDate(dayDate: Date): object | undefined {
         if (this.selectedReservedAndBookedBirthdays != null) {
            var birthdaysAtDate
            var atDate = DateFormatter.formatISODate(dayDate)

            birthdaysAtDate = this.selectedReservedAndBookedBirthdays.filter(
               (i) => DateFormatter.formatISODate(new Date(i.beginDateTime)) == atDate
            )

            return birthdaysAtDate
         }
      }, */

    getCalendarEvents() {
      let events: CalendarEventJson[] = [];

      if (this.selectedReservedAndBookedBirthdays != null) {
        for (let i = 0; i < this.selectedReservedAndBookedBirthdays.length; i++) {
          let event: CalendarEventJson = {
            title: "",
            beginDateTime: "",
            endDateTime: "",
            state: "",
            eventData: {},
          };

          event.title = this.selectedReservedAndBookedBirthdays[i].customer.guardianLastName;
          event.beginDateTime = this.selectedReservedAndBookedBirthdays[i].beginDateTime;
          event.endDateTime = this.selectedReservedAndBookedBirthdays[i].endDateTime;
          event.state = this.selectedReservedAndBookedBirthdays[i].state;

          event.eventData = this.selectedReservedAndBookedBirthdays[i];

          events.push(event);
        }
      }

      return events;
    },

    calenderCurrentYearMonth(year: number, month: number) {
      this.currentCalenderYearMonth = [year, month];
    },

    openDetails(item: BirthdayBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedBirthdayId = item.ID;
      } else {
        this.selectedBirthdayId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.reloadSelectedBirthdays();
      }
    },

    currentCalenderYearMonth: function () {
      this.loadSelectedReservedAndBookedBirthdays();
    },
  },
  computed: {},
});
